module.exports = __webpack_public_path__ + "static/XPS_App-c56704f9524822b4bcf49c0c3165179b.mp4";